import React from 'react';
export function StorySection() {
  return <section className="py-6 text-gray-800" data-id="element-269">
      <p className="text-lg mb-6 leading-relaxed" data-id="element-270">
        It was 7:30 AM on a Tuesday when Linda Martinez realized she had become
        'that woman.'
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-271">
        You know the one. The woman who grips the stair railing with both hands.
        The woman who winces getting out of chairs. The woman who makes excuses
        about why she can't join family walks.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-272">
        At 58, Linda had been dealing with knee pain for three years. What
        started as occasional stiffness had evolved into daily agony that
        dictated every decision she made.
      </p>
      <p className="mb-6 leading-relaxed italic border-l-4 border-gray-300 pl-4" data-id="element-273">
        "I remember the exact moment I knew things had to change," Linda tells
        me over coffee. "My 6-year-old granddaughter, Emma, asked me why I
        walked like her great-grandmother... who's 89 and uses a walker."
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-274">
        That night, Linda couldn't sleep. Not from the pain – though her knees
        throbbed constantly – but from the crushing realization that this
        vibrant, active woman who raised four children and ran a business was
        becoming invisible.
      </p>
      <p className="mb-4 leading-relaxed" data-id="element-275">She was tired of:</p>
      <ul className="list-disc pl-8 mb-6 space-y-2" data-id="element-276">
        <li data-id="element-277">Avoiding stairs whenever possible</li>
        <li data-id="element-278">Sitting out family activities</li>
        <li data-id="element-279">Feeling 20 years older than her age</li>
        <li data-id="element-280">The pitying looks from friends and family</li>
        <li data-id="element-281">Being defined by her limitations instead of her strength</li>
      </ul>
      <p className="mb-6 leading-relaxed font-medium" data-id="element-282">
        But what happened next changed everything. In just 10 minutes a day,
        using what she calls her "weird little morning ritual," Linda eliminated
        her knee pain completely. No pills. No surgery. No expensive doctor
        visits.
      </p>
      <p className="mb-6 leading-relaxed" data-id="element-283">
        Today, she hikes with her husband, chases her grandchildren, and moves
        with the confidence of a woman half her age.
      </p>
      <p className="text-xl font-bold mb-6" data-id="element-284">Here's how she did it...</p>
    </section>;
}